import { Icon, IconProps } from "@chakra-ui/react";

function MoreIcon(props: IconProps) {
	return (
		<Icon
			viewBox="0 0 36 36"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M16.3333 18C16.3333 17.0795 17.0795 16.3333 18 16.3333C18.9205 16.3333 19.6667 17.0795 19.6667 18C19.6667 18.9205 18.9205 19.6667 18 19.6667C17.0795 19.6667 16.3333 18.9205 16.3333 18Z"
				fill="black"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M22.1667 18C22.1667 17.0795 22.9129 16.3333 23.8333 16.3333C24.7538 16.3333 25.5 17.0795 25.5 18C25.5 18.9205 24.7538 19.6667 23.8333 19.6667C22.9129 19.6667 22.1667 18.9205 22.1667 18Z"
				fill="black"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M10.5 18C10.5 17.0795 11.2462 16.3333 12.1667 16.3333C13.0871 16.3333 13.8333 17.0795 13.8333 18C13.8333 18.9205 13.0871 19.6667 12.1667 19.6667C11.2462 19.6667 10.5 18.9205 10.5 18Z"
				fill="black"
			/>
		</Icon>
	);
}

export default MoreIcon;
